const API = process.env.REACT_APP_BACKEND_URL;

export const streamSse = async (path, body, onEvent) => {
  const res = await fetch(`${API}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(typeof err.detail === 'string' ? err.detail : 'AI request failed');
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let finished = false;
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split('\n\n');
    buffer = parts.pop();
    parts.forEach((part) => {
      const line = part.trim();
      if (!line.startsWith('data:')) return;
      const evt = JSON.parse(line.slice(5).trim());
      if (evt.error) throw new Error(evt.error);
      if (evt.done) finished = true;
      onEvent(evt);
    });
  }
  if (!finished) throw new Error('The AI response was interrupted. Please try again.');
};
